module.exports = __webpack_public_path__ + "img/study-jimbaran.5b848591.jpg";